import React from "react";

import CloseSvg from "../../assets/images/icons/close_gray.svg";

export const CloseGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={CloseSvg}
        alt={alt || "Close"}
    />
);
